export default class News{
    newsList : any;


    constructor() {
        this.newsList = this.getNewsList();
    }

    getNewsItem(item){
        for(let i = 0; i < this.newsList.length; i++) {
            let obj = this.newsList[i];
            if (item == obj.header){
                return obj;
            }
        }
    }


    getNewsList() {
        const cmp = function(x, y){
            return x > y ? 1 : x < y ? -1 : 0;
        };


        const arr = [
            {
                header: 'Treffpunkt Landwirtschaft - Hausmesse 2025',
                type: false,
                priority: 0,
                date: "05.03.2024",
                furtherInfo: false,
                items: [
                    {
                        text: "Flyer im Anhang beachten!",
                        bold: true
                    },
                ],
                images : ["hausmesse_25.jpg","hausmesse_25.jpg"],
                mainImage: "hausmesse_25.jpg"
            },
            {
                header: 'Treffpunkt Landwirtschaft - Hausmesse 2024',
                type: false,
                priority: 0,
                date: "27.02.2024",
                furtherInfo: false,
                items: [
                    {
                        text: "Flyer im Anhang beachten!",
                        bold: true
                    },
                ],
                images : ["hausmesse_1.jpg","hausmesse_2.jpg","hausmesse_3.jpg","hausmesse_4.jpg","hausmesse_5.jpg","hausmesse_6.jpg", "hausmesse_7.jpg",
                "hausmesse_8.jpg"],
                mainImage: "hausmesse_1.jpg"
            },
            {
                header: 'Kuhn bei Mehele',
                type: true,
                priority: 1,
                furtherInfo: false,
                date: "27.01.2022",
                items: [
                    {
                        text: "Flyer im Anhang beachten!",
                        bold: true
                    },
                ],
                images : ["kuhn_mehele.jpg","kuhn_mehele.jpg"],
                mainImage: "kuhn_mehele.jpg"
            },
            {
                header: 'Claas Arion 400 - Die glorreichen 7',
                type: false,
                priority: 0,
                date: "28.09.2021",
                furtherInfo: false,
                items: [
                    {
                        text: "Claas Arion 400 mit 7 Modellen von 90 bis 150 PS",
                        bold: true
                    },
                    {
                        text: "Durchzugsstarker 4 – Zylinder TurboDieselmotor mit 4,50 lt. Hubraum ( 90-150 PS) Stufe 5",
                        bold: false
                    },
                    {
                        text: "Klappbares Kühlersystem gut zu reinigen, günstig im Verbrauch, einteilige Motorhaube",
                        bold: false
                    },
                    {
                        text: "2 Motordrehzahlspeicher, 3-fach Zapfwelle, Zapfwellenautomatik, Heckbedienung",
                        bold: false
                    },
                    {
                        text: "Geräumige Kabine mit Heizung, Klimaanlage, Luftsitz, Beifahrersitz gepolstert und Radio",
                        bold: false
                    },
                    {
                        text: "3 Kabinenvarianten – Niedrigdach mit Luke, Normaldach mit Luke, Panoramadach",
                        bold: false
                    },
                    {
                        text: "6 + 4 Arbeitsscheinwerfer vorne und hinten, Rundumleuchte klappbar",
                        bold: false
                    },
                    {
                        text: "verstellbares Lenkrad vor-zurück und auf-ab, Ablagefächer, Kühlfach",
                        bold: false
                    },
                    {
                        text: "Vorderachs-  und Kabinenfederung( Option), robuste, stabile Kunststoffkotflügel hinten",
                        bold: false
                    },
                    {
                        text: "Robustes 4- oder 6-fach Lastschaltgetriebe mit guter Abstufung jahrelang am Markt",
                        bold: false
                    },
                    {
                        text: "Revershiftschaltung mit 9-stufiger Feineinstellung, Hubkräfte bis 5400 kg",
                        bold: false
                    },
                    {
                        text: "Hydraulikleistung mit 110 lt. Loadsensing, Entnahmemenge 42 Liter,",
                        bold: false
                    },
                    {
                        text: "3 mechanische Steuergeräte mit 6 Ölanschlüssen hinten ( bis 10 Anschlüsse möglich )",
                        bold: false
                    },

                    {
                        text: "2 elektrische Steuergeräte zusätzlich über Joystick in der Armlehne für vorne und hinten",
                        bold: false
                    },
                    {
                        text: "Heckbedienung für Zapfwelle und Hubwerk hinten links und rechts",
                        bold: false
                    },
                    {
                        text: "Frontkraftheber und 2-Leiter Druckluftanlage im Serienumfang enthalten !",
                        bold: true
                    },
                    {
                        text: "z.B.  Arion 410, 90 PS - schon um  69.800.- incl. 20 % Mwst. am Hof",
                        bold: true
                    },
                    {
                        text: "Finanzierung – Garantie bis 3 Jahre – weitere Optionen möglich",
                        bold: true
                    },
                    {
                        text: "kommen Sie jetzt zur Probefahrt",
                        bold: true
                    }

                ],
                images : ["claas_arion_400_1.jpg","claas_arion_400_2.jpg","claas_arion_400_3.jpg","" +
                "claas_arion_400_4.jpg","claas_arion_400_5.jpg","claas_arion_400_6.jpg","claas_arion_400_7.jpg",
                    "claas_arion_400_8.jpg"],
                mainImage: "claas_arion_400_7.jpg"
            },
            {
                header: 'Claas Axion bei Mehele',
                type: false,
                priority: 0,
                date: "12.07.2021",
                furtherInfo: false,
                items: [
                    {
                        text: "Anlieferung eines Claas Axion 850 für einen unserer Kunden",
                        bold: true
                    },
                    {
                        text: "50 km/h bei 264 PS",
                        bold: true
                    },
                    {
                        text: "gefederte Vorderachse, gefederte Kabine",
                        bold: true
                    },
                    {
                        text: "Hexaschift-Getriebe, Fronthydraulik und Frontzapfwelle",
                        bold: true
                    },
                    {
                        text: "Druckluftbremsanlage, LED Beleuchtung usw.",
                        bold: true
                    },

                ],
                images : ["claas_axion.jpg","claas_axion.jpg"],
                mainImage: "claas_axion.jpg"

            },
            {
                header: 'Carraro bei Mehele',
                type: true,
                priority: 1,
                furtherInfo: false,
                date: "09.04.2021",
                items: [
                    {
                        text: "Flyer im Anhang beachten!",
                        bold: true
                    },
                ],
                images : ["mehele_carraro.jpg","mehele_carraro.jpg"],
                mainImage: "mehele_carraro.jpg"
            },
            {
                header: 'Rapid bei Mehele',
                type: true,
                priority: 1,
                furtherInfo: false,
                date: "09.04.2021",
                items: [
                    {
                        text: "Flyer im Anhang beachten!",
                        bold: true
                    },
                ],
                images : ["mehele_rapid.jpg","mehele_rapid.jpg"],
                mainImage: "mehele_rapid.jpg"
            },
            {
                header: 'Ableben Arnold Mehele',
                type: false,
                priority: 0,
                furtherInfo: false,
                imgAlign: "normal",
                date: "16.03.2021",
                items: [
                    {
                        text: "Liebe Freunde der Firma Mehele Landtechnik, sehr geehrte Geschäftspartner,"
                    },
                    {
                        text: "leider müssen wir euch die traurige Nachricht vom Ableben des "
                    },
                    {
                        text: "Herrn Arnold Mehele",
                        bold: true
                    },
                    {
                        text: "mitteilen."
                    },
                    {
                        text: "Arnold geb. 05.01.1929 war mit Leib und Seele Schmiedemeister, Landtechniker und Händler.\n" +
                            "Nach seiner Tätigkeit in jungen Jahren als Schmied und Wagenbauer begann er Ende der 50-er Jahre mit dem Vertrieb und der Reparatur von Landmaschinen und Traktoren.\n" +
                            "Führende Landmaschinenhersteller schenkten ihm das Vertrauen über Jahrzehnte. \n" +
                            "1994 übernahmen seine Söhne Rainer und Stefan den Landtechnikbetrieb und führen diesen bis heute mit den erfolgreichen Marken weiter.\n" +
                            "\n"
                    },
                    {
                        text: "\n" +
                            "In seiner spärlichen Freizeit widmete sich Arnold Mehele dem aktiven Turnsport und der Leichtathletik, wo er zahlreiche Meistertitel erringen konnte. \n" +
                            "Dies hielt ihn gesundheitlich fit und er war als Seniorchef bis ins hohe Alter von über 90 Jahren täglich im Betrieb unterwegs.\n" +
                            "Im vergangenen November verließen ihn jedoch allmählich seine Kräfte und so hat er nun am 15. März 2021 für immer Feierabend gemacht."
                    },
                    {
                        text: "Wir werden Arnold stets in bester Erinnerung behalten.",
                        bold: true
                    }

                ],
                images : ["Arnold_Mehele.jpg","Arnold_Mehele.jpg"],
                mainImage: "Arnold_Mehele_1.jpg"
            },
            {
                header: 'Fertigstellung neues Betriebsgebäude',
                type: false,
                priority: 0,
                imgAlign: "normal",
                date: "07.12.2020",
                furtherInfo: false,
                items: [
                    {
                        text: "Nach rund 15 monatiger Bauzeit wurde nun das neue Betriebsgebäude, neben der bestehenden Lager und Ausstellungshalle an der Landesstraße zwischen Hohenems und Dornbirn, in Betrieb genommen. Der Standort im Zentrum von Hohenems wurde aufgelassen."
                    },
                    {
                        text: "Der Neubau besteht aus Büro- und Verkaufsräumen, Ersatzteillager, Werkstätte sowie Personal und Besprechungsraum. Am neuen, modernen Standort, bieten wir ein umfangreiches Ersatzteillager und die Beschaffung sämtlicher Ersatzteile und Zubehör für Landmaschinen und landwirtschaftlichen Fahrzeugen aller Marken bis hin zum „Oldie“. In der bestens ausgestatteten neuen Werkstätte, mit ausgebildeten Landtechnikern, führen wir Service, Reparaturen von Landmaschinen, Traktoren und Transportern sowie Kleingeräten aller Marken durch. 2 Mobile Werkstattbusse sorgen für rasche Hilfe am Hof. Pickerlüberprüfungen nach § 57a für landwirtschaftliche Zugmaschinen der Klasse T und Transporten bis 50 km/h gehören ebenfalls zu unseren Werkstattleistungen."
                    },
                    {
                        text: " Besuchen Sie jederzeit unsere frei zugängliche, großzügige Dauerausstellung von Neuer – und Gebrauchter Landtechnik."
                    }

                ],
                images : ["neueroeffnung_1.jpg","neueroeffnung_2.jpg","neueroeffnung_3.jpg"],
                mainImage: "neueroeffnung_1.jpg"
            },
            {
                header: 'Rapid Wiesenegge – 2m Arbeitsbreite',
                type: true,
                priority: 1,
                date: "05.03.2021",
                furtherInfo: false,
                items: [
                    {
                        text: "mit speziellem Bodenanpassungsmechanismus",
                        bold: true
                    },
                    {
                        text: "gestossen – gezogene Ausführung mit Führungskufen",
                        bold: true
                    },
                    {
                        text: "besserer Aufwuchs, geringere Futterverschmutzung,",
                        bold: false
                    },
                    {
                        text: "beidseitig verwendbares Netz, ideal für Bergwiesen,",
                        bold: false
                    },
                    {
                        text: "passend an:  EURO, MONTA, VAREA, ORBITO, ...",
                        bold: false
                    },
                    {
                        text: "Jetzt informieren bei Ihrem  RAPID Partner",
                        bold: true
                    },
                ],
                images : ["rapid_wiesenegge_1.jpg"],
                mainImage: "rapid_wiesenegge_1.jpg"
            },
            {
                header: 'CLAAS  Radlader TORION – Knicklenker',
                type: true,
                priority: 1,
                date: "20.01.2021",
                furtherInfo: false,
                items: [
                    {
                        text: "Kleine Baureihe von 63 bis 106 PS",
                        bold: true
                    },
                    {
                        text: "Große Baureihe von 140 bis 228 PS",
                        bold: true
                    },
                    {
                        text: "Komfortable Kabine zum Wohlfühlen",
                        bold: false
                    },
                    {
                        text: "Macht Freude bei jeder Bedienung",
                        bold: false
                    },
                    {
                        text: "Umfangreiche Serienausstattung",
                        bold: false
                    },
                    {
                        text: "Nützen Sie jetzt die 7 + 7 % Aktion",
                        bold: true
                    },
                ],
                images : ["claas_knicklenker_1.jpg","claas_knicklenker_2.jpg","claas_knicklenker_3.jpg","claas_knicklenker_4.jpg","claas_knicklenker_5.jpg",
                    "claas_knicklenker_6.jpg"],
                mainImage: "claas_knicklenker_1.jpg"
            },
            {
                header: 'CLAAS Mittelschwader Aktion',
                type: true,
                priority: 1,
                furtherInfo: false,
                date: "18.01.2021",
                items: [
                    {
                        text: "Liner 2600  - 6,20 bis 6,80 m Arbeitsbreite,   11 x 4 Zinken",
                        bold: true
                    },
                    {
                        text: "Liner 2700  - 6,80 bis 7,40 m Arbeitsbreite,   12 x 4 Zinken",
                        bold: true
                    },
                    {
                        text: "Schwadglocke im Ölbad,  Schwadarme mit Sollbiegestelle,  4 oder 6 -Rad Fahrwerk",
                        bold: false
                    },
                    {
                        text: "Dreidimensionale Bodenanpassung, Lenkachse hinten, gemacht für den Dauereinsatz",
                        bold: false
                    },
                    {
                        text: "Nützen Sie jetzt die Verkaufshilfe von EUR  600.- pro Kreisel",
                        bold: true
                    },
                    {
                        text: "+  7 % Covid Förderung",
                        bold: true
                    },
                    {
                        text: "Gültig auch für Seitenschwader und Einzelschwader",
                        bold: false
                    }
                ],
                images : ["Claas_Mittelschwader_1.jpg","Claas_Mittelschwader_2.jpg", "Claas_Mittelschwader_3.jpg","Claas_Mittelschwader_4.jpg","Claas_Mittelschwader_5.jpg",
                    "Claas_Mittelschwader_6.jpg","Claas_Mittelschwader_7.jpg","Claas_Mittelschwader_8.jpg"],
                mainImage: "Claas_Mittelschwader_1.jpg"
            },
        {
            header: 'Claas - DISCO Scheibenmähwerke',
            type: true,
            priority: 1,
            furtherInfo: false,
            date: "11.12.2020",
            items: [
                {
                    text: "Front- und Heckanbau 2,60 bis 11,00 m Arbeitsbreite",
                    bold: true
                },
                {
                    text: "mit und ohne Aufbereiter – Mähwerke für jeden Betrieb",
                    bold: false
                },
                {
                    text: "MAX CUT Mähbalken – der stärkste Balken am Markt",
                    bold: false
                },
                {
                    text: "aus einem Stück geprägte Wanne – sauber verschraubt",
                    bold: false
                },
                {
                    text: "optimierter Tunneleffekt zwischen Boden u. Mähblatt",
                    bold: false
                },
                {
                    text: "nach vorne versetzte Mähscheiben- maximaler Schnitt",
                    bold: false
                },
                {
                    text: "geschliffene Zahnräder für ruhigen und  leisen Lauf ",
                    bold: false
                },
                {
                    text: "SAFETYLINK Module für die einzelnen Mähscheiben",
                    bold: false
                },
                {
                    text: "robuste Messerhalter, carbitbeschichtet -verschleißarm",
                    bold: false
                },
                {
                    text: "komfortabler Klingenschnellwechsel leicht zugänglich",
                    bold: false
                },
                {
                    text: "beste Bodenanpassung, dank durchdachter Kinematik",
                    bold: false
                },
                {
                    text: "beste Materialien für eine lange Lebensdauer",
                    bold: true
                },



            ],
            images : ["maehwerk_1.jpg","maehwerk_2.jpg"],
            mainImage: "maehwerk_1.jpg"
        },
        {
            header: 'CARRARO Mähtrak TTR 7600 Infinity - stufenlos',
            type: true,
            priority: 1,
            furtherInfo: false,
            date: "07.12.2020",
            items: [
                {
                    text: "Abgasstufe 5 / 75 PS 4-Zylinder Dieselmotor",
                    bold: true
                },
                {
                    text: "stufenlos fahren in 6 Geschwindigkeitsbereichen",
                    bold: false
                },
                {
                    text: "40 km/h, kraftvoll durch Linde-Antriebstechnik",
                    bold: false
                },
                {
                    text: "Powershuttle Wendeschaltung",
                    bold: false
                },
                {
                    text: "Automatik- und Zapfwellenmodus, Motordrehzahlspeicher",
                    bold: false
                },
                {
                    text: "Joystickbedienung mit 5 Ölanschlüssen, Kabine",
                    bold: false
                },
                {
                    text: "Heizung, Klimaanlage, Luftsitz",
                    bold: false
                },
                {
                    text: "Räder 480/45-17",
                    bold: false
                },
                {
                    text: "alle Vorzüge eines Wendetracs",
                    bold: true
                },
                {
                    text: "schon um € 66.000.- inkl. MWSt. am Hof",
                    bold: true
                }

            ],
            images : ["carraro_7600_1.jpg","carraro_7600_2.jpg"],
            mainImage: "carraro_7600_1.jpg"
        },
        {
            header: 'CLAAS Arion 410A',
            type: true,
            date: "07.12.2020",
            priority: 1,
            furtherInfo: false,
            items: [
                {
                    text: "4-Zylinder FPT DieselmotoBer - 4,50 lt.Hubraum",
                    bold: true
                },
                {
                    text: "Fronthydraulik und Frontzapfwelle sowie 2 Ölanschlüsse vorne",
                    bold: false
                },
                {
                    text: "Bereifung 540/65- R34 hinten., 440/65- R24 vorne ",
                    bold: false
                },
                {
                    text: "Druckluftanlage 2-Leiter, hydr. Anhängerbremsventil",
                    bold: false
                },
                {
                    text: "16+16 Gang Getriebe, 40 km/h,4-fach Lastschaltung",
                    bold: false
                },
                {
                    text: "100 lt. Hydraulikleistung, Niedrigdach Höhe 2,54 m",
                    bold: false
                },
                {
                    text: "Klimaanlage, EHR, Radio, 2x4 Arbeitsscheinwerfer",
                    bold: false
                },
                {
                    text: "3 dw Steuergeräte, 6 Ölanschlüsse, 3-fach Zapfwelle",
                    bold: false
                },
                {
                    text: "Austria Edition Aktion",
                    bold: true
                },
                {
                    text: "schon um € 68.800.- inkl. MWSt.",
                    bold: true
                }

            ],
            images : ["claas_arion_1.jpg"],
            mainImage: "claas_arion_1.jpg"
        },
        {
            header: 'CLAAS Elios 210A',
            type: true,
            date: "07.12.2020",
            priority: 1,
            furtherInfo: false,
            items: [
                {
                    text: "4-Zylinder FPT Dieselmotor - 3,40 lt.Hubraum",
                    bold: true
                },
                {
                    text: "Kabine, Heizung, Luftsitz, 24/24 Gang-Getriebe",
                    bold: false
                },
                {
                    text: "40 km/h, 2-fach Lastschaltung, 4 Ölanschlüsse",
                    bold: false
                },
                {
                    text: "Schnellkuppler, schnellverstellbares Zugmaul",
                    bold: false
                },
                {
                    text: "Bereifung  vorne 420/65-20 hinten 540/65-30",
                    bold: false
                },
                {
                    text: "Aktionspreis um € 42.800.- inkl. MWSt.",
                    bold: true
                }
            ],
            images : ["claas_elios_1.jpg"],
            mainImage: "claas_elios_1.jpg"
        },
        {
            header: 'RAPID MÄHER',
            type: true,
            priority: 1,
            furtherInfo: false,
            date: "07.12.2020",
            items: [
                {
                    text: "meisterverkaufte Einachsmäher",
                    bold: true
                },
                {
                    text: "7 bis 23 PS  Benzinmotoren",
                    bold: false
                },
                {
                    text: "Schlagkräftige Mähmaschinen für extreme Steilhanglagen",
                    bold: false
                },
                {
                    text: "auch als Eingrasmäher oder Kommunaleinsatz",
                    bold: false
                },
                {
                    text: "stufenloser Fahrantrieb",
                    bold: false
                },
                {
                    text: "Holm und Einzelhebellenkung",
                    bold: false
                },
                {
                    text: "Zero-Turn aktiv Lenkung",
                    bold: false
                },
                {
                    text: "Vielzahl von Anbaugeräten",
                    bold: false
                }
            ],
            images : [],
            mainImage: "rapid_maeher_1.jpg"
        },

        ];

      /*arr.sort(function(a, b){
            //note the minus before -cmp, for descending order
            return cmp(
                [cmp(a.priority, b.priority), cmp(new Date(a.date), new Date(b.date))],
                [cmp(b.priority, a.priority), cmp(new Date(a.date), new Date(b.date))]
            );
        });

       */

        return arr;
    }

}
